import {format} from 'timeago.js';
import _ from 'lodash';
import moment from "moment";

export function rideStatus(value) {
    let className;
    let displayValue;
    switch (value) {
        case 'COMPLETED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Completed';
            break;

        case 'PENDING':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Pending';
            break;

        case 'ACCEPTED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Accepted';
            break;

        case 'TO_PICKUP':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Transit to Pickup'
            break;

        case 'WAITING_PICKUP':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Waiting for Pickup';
            break;

        case 'STOPPED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Stopped';
            break;

        case 'IN_PROGRESS':
            className = 'bg-light-warning border-light-warning text-warning';
            displayValue = 'In-progress';
            break;

        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Canceled';
            break;

        case 'DRIVER_NOT_FOUND':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Driver not found';
            break;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function rideType(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'DISPATCHED':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Dispatched';
            break;

        case 'ORDERED':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Ordered';
            break;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function driverStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'AVAILABLE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Available';
            break;

        case 'ON_RIDE':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'On ride';
            break;

        case 'OFFLINE':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Offline';
            break;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function geoZoneType(value) {

    let className;
    let displayValue;

    switch (value) {
        case 'SERVICE_AREA':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Service Area';
            break;
        case 'FARE_CONFIG_ZONE':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Fare Config Zone';
            break;
        case 'RESTRICTED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Restricted';
            break;
        case 'PROMOTIONAL':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Promotional';
            break;
        case 'CUSTOM':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Custom';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Unknown';
            break;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function userDetailsWithThumbnail(data, row, url) {
    if (_.isEmpty(data)) {
        return 'N/A';
    }

    return `<div class="d-flex align-items-center gap-2">
              <span class="table-thumb d-none d-lg-block">
                <span class="name-short-form">
                    ${data.match(/(^\S\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()}
                </span>
              </span>
              
              <div>
                <a class="fs-13" href="${url}">${data}</a>
               </div>
          </div>`;
}

export function zonedDateTime(value) {
    if (_.isEmpty(value) || isNaN(new Date(value))) {
        return "N/A";
    }

    return `<span title="${moment(value).format('MMM DD, YYYY')}"> ${format(new Date(value))}</span>`
}

export function booleanBadgeRender(value) {
    return value
        ? `<span class="badge badge-success">Yes</span>`
        : `<span class="badge badge-danger">No</span>`;
}

export function activeBadgeRender(value) {
    return value ?
        '<span class="badge bg-success">Active</span>' :
        '<span class="badge bg-danger">Inactive</span>';
}

export function potentialUndefinedColumn(value) {
    return value ? value : `N/A`;
}

export function editAndDeleteCTA(data, type, row, meta, editCallback, deleteCallback) {

    const hash = hashCode(row).toString();

    setupEditAndDeleteEventListeners(editCallback, deleteCallback, row, meta, hash);
    return `
    <button class="btn btn-lg btn-link p-0 edit-btn-${hash}" data-id="${row.id ? row.id : meta.row}">
      <i class="icon-pencil-alt"></i>
    </button>
    <button class="btn btn-lg btn-link p-0 del-btn-${hash}" data-id="${row.id ? row.id : meta.row}">
      <i class="icon-trash text-danger"></i>
    </button>`;
}

export function findDriverOnMapCTA(data, type, row, meta, findDriverCallback) {
    setupFindDriverOnMapCTAEventListeners(findDriverCallback, row, meta);
    return `
  <button class="btn btn-link p-0 find-btn-${row.id}" data-id="${row.id ? row.id : meta.row} title="Find driver on map.">
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>`;
}


/**
 *
 *Event listeners
 */

function setupEditAndDeleteEventListeners(editCallback, deleteCallback, row, meta, hash) {


    $(document).on('click', `.edit-btn-${hash}`, function () {
        editCallback(row, meta);
    });


    $(document).on('click', `.del-btn-${hash}`, function () {
        deleteCallback(row, meta);
    });
}

function setupFindDriverOnMapCTAEventListeners(findDriverCallback, row) {
    $(document).on('click', `.find-btn-${row.driverId}`, function () {
        findDriverCallback(row);
    });

}


function hashCode(obj) {

    let str = "";
    Object.keys(obj).forEach(key => {
        str += obj[key];
    });

    let hash = 0;
    if (str.length === 0) return hash;

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }

    return hash;
}

// Account-related renderers
export function accountStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'SUSPENDED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Suspended';
            break;
        case 'CLOSED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Closed';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function invoiceStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'DRAFT':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Draft';
            break;
        case 'SENT':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Sent';
            break;
        case 'PAID':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Paid';
            break;
        case 'OVERDUE':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Overdue';
            break;
        case 'CANCELLED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-light border-light text-dark';
            displayValue = value;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function currency(value) {
    if (value === null || value === undefined) {
        return '$0.00';
    }
    const formatted = parseFloat(value).toFixed(2);
    return `$${formatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function ledgerEntryType(value) {
    let icon;
    let className;
    let displayValue;

    switch (value) {
        case 'CHARGE':
            icon = 'fa-arrow-up';
            className = 'text-danger';
            displayValue = 'Charge';
            break;
        case 'PAYMENT':
            icon = 'fa-arrow-down';
            className = 'text-success';
            displayValue = 'Payment';
            break;
        case 'CREDIT':
            icon = 'fa-gift';
            className = 'text-info';
            displayValue = 'Credit';
            break;
        case 'ADJUSTMENT':
            icon = 'fa-exchange-alt';
            className = 'text-warning';
            displayValue = 'Adjustment';
            break;
        default:
            icon = 'fa-circle';
            className = 'text-secondary';
            displayValue = value;
    }

    return `<i class="fa ${icon} ${className}"></i> ${displayValue}`;
}

export function shiftStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'DRAFT':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Draft';
            break;
        case 'PUBLISHED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Published';
            break;
        case 'IN_PROGRESS':
            className = 'bg-info border-light-info text-info';
            displayValue = 'In progress';
            break;
        case 'CLOSED':
            className = 'bg-dark border-light-dark text-dark';
            displayValue = 'Closed';
            break;
        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function shiftSignupStatus(value) {
    let className;
    let displayValue;

    // A lookup with a fallback rather than an exhaustive switch: settlement outcomes are expected to
    // grow (#135), and a status this build doesn't know must render as itself rather than blank.
    switch (value) {
        case 'SIGNED_UP':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Signed up';
            break;
        case 'WITHDRAWN':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Withdrawn';
            break;
        case 'COMPLETED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Completed';
            break;
        case 'NO_SHOW':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'No show';
            break;
        case 'SHIFT_CANCELLED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Shift cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function earningTransferStatus(value) {
    let className;

    switch (value) {
        case 'COMPLETED':
            className = 'bg-success border-light-success text-success';
            break;
        case 'PENDING':
        case 'PROCESSING':
            className = 'bg-info border-light-info text-info';
            break;
        case 'FAILED':
            className = 'bg-danger border-light-danger text-danger';
            break;
        case 'SKIPPED':
            className = 'bg-warning border-light-warning text-warning';
            break;
        default:
            // No transfer row at all — e.g. a driver who out-earned their shift guarantee, so nothing
            // was ever owed. That is not a fault and must not render as one.
            return `<span class="text-muted">&mdash;</span>`;
    }

    return `<span class="btn-sm ${className}"> ${value} </span>`;
}

/**
 * Money that may legitimately be absent, rendered as a dash rather than $0.00.
 *
 * `currency()` maps null to "$0.00", which on a settlement column would assert the driver earned or was
 * credited nothing — a false statement, and precisely the one issue #136 exists to stop the product
 * making. An unsettled sign-up, and one settled before the snapshot columns shipped, both carry nulls.
 */
export function optionalCurrency(value) {
    return (value === null || value === undefined) ? `<span class="text-muted">&mdash;</span>` : currency(value);
}

// Wallet admin renderers (epic #173, issue #169).

/**
 * Money already in minor units (BIGINT cents, per D1) rendered as a dollar figure — `currency()`
 * assumes its input is already dollars, which every wallet admin DTO deliberately is not on the wire
 * (amount*Minor fields), to keep the server the only place a minor/major conversion happens.
 */
export function minorCurrency(value) {
    if (value === null || value === undefined) {
        return '$0.00';
    }
    return currency(value / 100);
}

export function walletStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'FROZEN':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Frozen';
            break;
        case 'SUSPENDED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Suspended';
            break;
        case 'CLOSED':
            className = 'bg-dark border-light-dark text-dark';
            displayValue = 'Closed';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function walletTransactionType(value) {
    let className;

    switch (value) {
        case 'TOP_UP':
        case 'PROMOTIONAL_CREDIT':
        case 'SUPPORT_CREDIT':
        case 'REFERRAL_CREDIT':
        case 'CHARGEBACK_REVERSAL':
        case 'REVERSAL':
            className = 'text-success';
            break;
        case 'RIDE_PAYMENT':
        case 'CHARGEBACK':
        case 'EXPIRY':
            className = 'text-danger';
            break;
        case 'RIDE_REFUND':
        case 'TOP_UP_REFUND':
            className = 'text-info';
            break;
        case 'MANUAL_ADJUSTMENT':
            className = 'text-warning';
            break;
        default:
            className = 'text-secondary';
    }

    const label = (value || '').replaceAll('_', ' ');
    return `<span class="${className}">${label}</span>`;
}

export function walletAdjustmentRequestStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'PENDING_APPROVAL':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending approval';
            break;
        case 'APPROVED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Approved';
            break;
        case 'EXECUTING':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Executing';
            break;
        case 'EXECUTED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Executed';
            break;
        case 'EXECUTION_PENDING':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Refund in progress';
            break;
        case 'ESCALATED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Escalated';
            break;
        case 'FAILED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Failed';
            break;
        case 'REJECTED':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Rejected';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function walletTopUpRefundState(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'NONE':
            return `<span class="text-muted">&mdash;</span>`;
        case 'PENDING_UNKNOWN':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending';
            break;
        case 'REFUNDED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Refunded';
            break;
        case 'UNRECONCILED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Unreconciled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

export function subscriptionStatus(value) {
    let className;
    let displayValue;

    switch (value) {
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'INACTIVE':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Inactive';
            break;
        case 'PENDING':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending';
            break;
        case 'EXPIRED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Expired';
            break;
        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'None';
    }

    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}